// import AuthLayout from "../../components/";
import {
    Button,
    Col,
    Image,
    Layout,
    List,
    Row
} from "antd";
import {
    FaCheckCircle
} from "react-icons/fa";
import { useNavigate } from "react-router";
import { ImageUrl } from "../../helpers/Function";
import { useEffect } from "react";
// import router from "next/router";

function OnBoarding() {
    const navigate = useNavigate();

    const data1 = [
        {
            title: "Attach a logo to the portal.",
        },
        {
            title: "Create a referral code for users to self-enroll into a portal.",
        },
    ];

     useEffect(() => { window.scrollTo(0, 0); }, []);
    return (
        <>
            
            <Layout style={{ minHeight: "100vh", backgroundSize: "cover" }}>
                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={12}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c29.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={12}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Big Germs Little People – Health and Sanitation in the Preschool Environment</h4>
                                        <p className="text-p-16">
                                        Duration:2 Hours 30 Minutes
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                        Teachers, Assistant Teachers, Administrative and Family Service Staff, Nutrition Staff, Custodial Supervisor, Custodial Staff
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                        The “Big Germs Little People” training focuses on professional health and sanitation practices specifically tailored for the early care and education environment. Participants will delve into important topics such as environmental health management, disease transmission prevention, cross-contamination control, life safety measures, cleaning protocols, suitable cleaning products, and effective best parctice cleaning techniques. The training not only addresses these essential aspects but also emphasizes team cleaning concepts and regulatory compliance, ensuring a comprehensive approach to health and sanitation in preschool settings.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>


                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={12}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c30.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={12}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Ground Rules for Custodians: Upholding Professional Conduct and Integrity in Child Care Settings</h4>
                                        <p className="text-p-16">
                                        Duration:2 Hours 30 Minutes
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                        Teachers, Assistant Teachers, Administrative and Family Service Staff, Nutrition Staff, Custodial Supervisor, Custodial Staff
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                        The Comprehensive Training on Infectious Diseases and Contagious Illnesses aims to equip participants with a deep understanding of bacteria, viruses, fungi, and parasites, as well as their modes of transmission. By delving into these topics, participants will gain valuable knowledge to effectively combat and prevent the spread of illnesses, including the coronavirus. The training content is carefully curated based on information provided by reputable sources such as the CDC (Centers for Disease Control), WHO (World Health Organization), NYSOCFS, DOH (Department of Health), and the National Health and Safety Performance Standards.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>


                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={12}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c31.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={12}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Managing Infectious Diseases and Contagious Illnesses in Early Care and Education Settings</h4>
                                        <p className="text-p-16">
                                        Duration: 5 Hours
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                        Teachers, Assistant Teachers, Administrative and Family Service Staff, Nutrition Staff, Custodial Supervisor, Custodial Staff
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                        The Comprehensive Training on Infectious Diseases and Contagious Illnesses aims to equip participants with a deep understanding of bacteria, viruses, fungi, and parasites, as well as their modes of transmission. By delving into these topics, participants will gain valuable knowledge to effectively combat and prevent the spread of illnesses, including the coronavirus. The training content is carefully curated based on information provided by reputable sources such as the CDC (Centers for Disease Control), WHO (World Health Organization), NYSOCFS, DOH (Department of Health), and the National Health and Safety Performance Standards.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>

               


            </Layout>
        </>
    );
}

export default OnBoarding;
